// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

/**
 * Frontend runtime constants — single authority for timeout, retry, and
 * replay policy values. These were previously inline in apiBase.ts (timeout)
 * and chatStore.ts (replay retry).
 *
 * ISSUE-10: Frontend Timeout/Retry Constant Authority
 */

/** HTTP request timeout in milliseconds for chat API calls. */
export const API_DEFAULT_TIMEOUT_MS = 300_000;

/** Replay checkpoint retry policy for chatStore.replayCheckpoint. */
export const CHAT_REPLAY_RETRY = {
  /** Maximum number of replay attempts. */
  maxAttempts: 3,
  /** Base delay between retries in milliseconds (exponential backoff). */
  baseDelayMs: 800,
} as const;

// ── KB store named constants (CD-19) ────────────────────────────────
//
// `kbStore` previously carried two inline magic numbers on the active KB list
// path (`const concurrency = 6` and `limit = 50`).  They now live here as the
// named authority so the active UX path reads named constants instead of
// bare literals.

/** Concurrency for fanning out KB health/stats detail loads after `loadKbs`. */
export const KB_DETAIL_LOAD_CONCURRENCY = 6;

/** Default row limit when fetching per-KB retrieval metrics. */
export const KB_RETRIEVAL_METRICS_DEFAULT_LIMIT = 50;
